import React from "react"
import { Typography } from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"
import Chat from "./Chat"

const ChatRoot = ({ currentChat }) => {
  if (currentChat?.status === "matched" || currentChat?.status === "finished") return <Chat currentChat={currentChat} />

  return (
    <>
      <InfoIcon sx={{ color: "#ccc", m: 0.5, mt: 1 }} />

      {currentChat ? (
        <Typography variant="body2" sx={{ p: 1 }}>
          Du bekommst eine Benachrichtigung per E-Mail, sobald ein {currentChat.action === "buy" ? "Verkäufer" : "Käufer"} gefunden wird. Danach
          kannst du hier mit dem {currentChat.action === "buy" ? "Verkäufer" : "Käufer"} schreiben.
        </Typography>
      ) : (
        <Typography variant="body2" sx={{ p: 1 }}>
          Sobald du das Buch zum Kauf oder Verkauf eingestellt hast und ein passender Verkäufer oder Käufer gefunden wurde, kannst du hier Kontakt
          aufnehmen.
        </Typography>
      )}
    </>
  )
}

export default ChatRoot
